import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-at",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M0 160h640v160H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#c8102e",
		d: "M0 0h640v160H0zm0 320h640v160H0z"
	})]
});
export default SvgAt;
